import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import { NavigationItem } from '@shared/models/navigation-item';

@Component({
  standalone: false,
  selector: 'gstar-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationItemComponent {
  disabled = input<boolean>(false);
  selected = input<boolean | undefined>(false);
  active = input<boolean | undefined>(false);
  collapsed = input<boolean>(false);
  ariaExpanded = input<boolean | undefined | null>(false);
  content = input<string>('');
  item = input<NavigationItem>({} as NavigationItem);

  @Output() clickTrigger: EventEmitter<Event> = new EventEmitter();
  @Output() keyupTrigger: EventEmitter<Event> = new EventEmitter();

  clickItem(event: Event): void {
    this.clickTrigger.emit(event);
  }

  keyupEnter(event: Event): void {
    this.keyupTrigger.emit(event);
  }
}
